/* global axios */
import ApiClient from './ApiClient';

class ManagerChatAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/manager_chat`);
  }

  turn(conversationId, { prompt = null, images = [] } = {}) {
    const url = `${this.url}/${conversationId}/manager_chat/turn`;
    if (!images.length) return axios.post(url, { prompt });

    const form = new FormData();
    if (prompt) form.append('prompt', prompt);
    images.forEach(file => form.append('images[]', file));
    return axios.post(url, form);
  }

  accept(conversationId, { turnId, editedContent = null } = {}) {
    return axios.post(`${this.url}/${conversationId}/manager_chat/accept`, {
      turn_id: turnId,
      edited_content: editedContent,
    });
  }

  dismiss(conversationId) {
    return axios.post(`${this.url}/${conversationId}/manager_chat/dismiss`);
  }

  deleteMessage(conversationId, messageId) {
    return axios.delete(
      `${this.url}/${conversationId}/manager_chat/messages/${messageId}`
    );
  }

  rememberMessage(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/manager_chat/messages/${messageId}/remember`
    );
  }
}

export default new ManagerChatAPI();
